import { createStyles, makeStyles } from "@material-ui/core";
import { RelodeTheme } from "@relode/core";

export const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                width: "100vw",
                [theme.breakpoints.up("md")]: {
                    flexDirection: "row",
                },
                [theme.breakpoints.down("sm")]: {
                    height: "100%",
                    overflowX: "hidden",
                },
            },
            contentView: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflowY: "hidden",
                overflowX: "hidden",
            },
            bodyWrapper: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
            },
            mobileBodyWrapper: {
                marginTop: theme.relode.sizes.mobileAppBarHeight,
            },
            appBar: {
                position: "relative",
                zIndex: theme.zIndex.drawer + 1,
                backgroundColor: "transparent",
                boxShadow: "none",
                borderBottom: `1px solid ${theme.palette.divider}`,
                [theme.breakpoints.up("md")]: {
                    borderBottom: "none",
                },
            },
            contextArea: {
                marginBottom: theme.spacing(4),
            },
            toolbar: {
                display: "flex",
                flexDirection: "row",
            },
            logo: {
                flexGrow: 1,
            },
            addJobButton: {
                width: 136,
            },
        }),
    { name: "AppComponent" }
);
